import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { RequestForQuoteSupplierResponseDto } from "@interfaces/dto/requestForQuoteSupplierResponseDto.interface";
import { Service } from "@services/service";
import { Guid } from "guid-typescript";

@Injectable()
export class RequestForQuoteService extends Service {
	constructor(injector: Injector) {
		super("RequestForQuote", injector);
	}

	// API
	// Raise quotes for the billets and BOM lines chosen on a tool, to the suppliers chosen with them.
	createForProductionTool(data: { bomItemIds: number[]; productionToolId: number; supplierIds: number[]; toolOrderIds: number[] }){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/CreateForProductionTool`, data);
	}

	getForProductionTool(id: number){
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetForProductionTool/${id}`);
	}

	getForSalesOrder(id: number){
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetForSalesOrder/${id}`);
	}

	lost(id: number){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/Lost/${id}`, {});
	}

	public_ItemsForSupplierResponse(lookupId: Guid){
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/Public_ItemsForSupplierResponse/${lookupId}`);
	}

	public_SupplierSubmittedResponse(data: RequestForQuoteSupplierResponseDto){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/Public_SupplierSubmittedResponse`, data);
	}

	send(id: number){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/Send/${id}`, {});
	}
	
	sendRFQsForSalesOrder(id: number){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/SendRFQsForSalesOrder/${id}`, {});
	}

	won(id: number){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/Won/${id}`, {});
	}
}